/**
 * Shared left-nav active-route highlight styles.
 * Relies on @reach/router Link setting aria-current="page" when the route matches.
 */
export const navActiveStyles = {
  '& .MuiListItemButton-root': {
    marginBottom: 2,
  },
  '& .MuiListItemText-primary': {
    fontSize: '0.8rem !important',
  },
  '& .MuiListItemText-secondary': {
    fontSize: '0.7rem !important',
  },
  '& .report-cat-ribbon .MuiListItemText-primary': {
    fontSize: '0.8rem !important',
    fontWeight: '500 !important',
    letterSpacing: '0 !important',
    textTransform: 'none !important',
  },
  '& .MuiListItemIcon-root': {
    color: '#475569',
    minWidth: 28,
  },
  '& .MuiSvgIcon-root': {
    fontSize: '1.2rem !important',
  },
  '& .MuiCollapse-root .MuiListItemButton-root:not(.report-cat-ribbon)': {
    paddingLeft: '48px !important',
  },
  '& .MuiCollapse-root .MuiCollapse-root .MuiListItemButton-root:not(.report-cat-ribbon)': {
    paddingLeft: '80px !important',
  },
  '& .MuiCollapse-root > .MuiCollapse-wrapper .report-cat-ribbon.MuiListItemButton-root': {
    marginLeft: 16,
    width: 'calc(100% - 24px)',
  },
  '& a[aria-current="page"] .MuiListItemButton-root': {
    backgroundColor: 'rgba(15, 23, 42, 0.06) !important',
  },
  '& a[aria-current="page"] .MuiListItemText-primary': {
    fontWeight: 600,
    color: '#1e293b',
  },
  '& .MuiListItemButton-root[aria-current="page"]': {
    backgroundColor: 'rgba(15, 23, 42, 0.06) !important',
  },
  '& .MuiListItemButton-root[aria-current="page"] .MuiListItemText-primary': {
    fontWeight: 600,
    color: '#1e293b',
  },
  '& .MuiListItemButton-root.Mui-selected': {
    backgroundColor: 'rgba(15, 23, 42, 0.06) !important',
  },
  '& .MuiListItemButton-root.Mui-selected .MuiListItemText-primary': {
    fontWeight: 600,
    color: '#1e293b',
  },
  '& .MuiListItemButton-root.Mui-selected .MuiListItemIcon-root': {
    color: '#334155',
  },
};

export function isNavPathActive(pathname, to, { prefix = false } = {}) {
  if (!pathname || !to) return false;
  const path = String(pathname).replace(/\/$/, '') || '/';
  const target = String(to).replace(/\/$/, '') || '/';
  if (path === target) return true;
  if (prefix && path.startsWith(`${target}/`)) return true;
  return false;
}



// WEBPACK FOOTER //
// ./src/components/leftnav/navActiveStyles.js